import Exif from 'exif-js';
import Platform from '@/core/platform';
/**
 * 获取地址中的参数
 */
window.urlParams = function() {
  const url = location.search; //获取url中'?'符后的字串
  const params = {};
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1);
    str = str.split('&');
    for (let i = 0; i < str.length; i++) {
      params[str[i].split('=')[0]] = unescape(str[i].split('=')[1]);
    }
  }
  return params;
};

window.getParameterByName = function(name) {
  name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(location.href);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

window.platformCheck = function() {
  const userAgent = window.navigator.userAgent;
  let system = '';
  const result = {};
  const regExps = [
    [/xiaomai_ios/i, 'XiaoMaiIOS'],
    [/xiaomai_android/i, 'XiaoMaiAndroid'],
    [/micromessenger/i, 'microMessenger'],
    [/weibo/i, 'WeiBo'],
    [/qq/i, 'MQQBrowser123'],
  ];

  for (let i = 0, len = regExps.length; i < len; i++) {
    if (!system) {
      if (new RegExp('android', 'gi').test(userAgent)) {
        system = 'Android';
      } else if (new RegExp('iphone', 'gi').test(userAgent)) {
        system = 'IOS';
      } else {
        system = 'Other';
      }
    }

    if (regExps[i][0].test(userAgent)) {
      result.platform = regExps[i][1];
      i = len;
    }
  }
  result.system = system;
  return result;
};

window.changeDocumentTitle = function(title) {
  if (title) {
    if (Platform.isAlipay()) {
      AlipayJSBridge.call('setTitle', { title });
    } else {
      setTimeout(() => {
        document.title = title;
        const iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.onload = function() {
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 0);
        };
        document.body.appendChild(iframe);
      }, 0);
    }
  }
};

// 检测是否为正确的手机号码
window.isValidPhone = phone => {
  const tempPhone = Number(phone);
  return /^1(2|3|4|5|6|7|8|9)\d{9}$/.test(tempPhone);
};

window.formatWeekDate = timestamp => {
  if (!timestamp || !(parseInt(timestamp) > 0)) return '';
  const date = new Date(parseInt(timestamp));
  let w = date.getDay();
  let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

  return week[w];
};
window.randomString = function(len) {
  len = len || 32;
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const maxPos = chars.length;
  let pwd = '';
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

window.encryptCode = function() {
  if (!window.__encrpt_code__) {
    window.__encrpt_code__ = randomString(32);
  }
  return window.__encrpt_code__;
};

window.range = function(n) {
  const arr = [];
  for (var i = 0; i < n; i++) {
    arr.push(i > 9 ? i + '' : '0' + i);
  }
  return arr;
};

/**
 * 图片旋转
 * @param {*} canvas
 * @param {*} image
 */
window.rotateImage = function(canvas, image) {
  const ctx = canvas.getContext('2d');
  const width = canvas.width;
  const height = canvas.height;
  return new Promise((resolve, reject) => {
    try {
      Exif.getData(image, () => {
        // 图片旋转参数
        const orientation = Exif.getTag(image, 'Orientation');
        const deg = Math.PI / 180;
        console.log(orientation);
        switch (orientation) {
          case 3: // 180 度
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(180 * deg);
            ctx.drawImage(image, -width, -height, width, height);
            break;
          case 6: // 需要顺时针旋转 90 度
            if (window.phoneModel().isiOS) {
              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(image, 0, 0, width, height);
            }
            if (window.phoneModel().isAndroid) {
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90 * deg);
              ctx.drawImage(image, 0, -height, width, height);
            }
            break;
          case 8: // 需要逆时针旋转 90 度
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(-90 * deg);
            ctx.drawImage(image, -width, 0, width, height);
            break;
          default:
            if (window.phoneModel().isiOS) {
              canvas.width = height;
              canvas.height = width;
              ctx.drawImage(image, 0, 0, height, width);
            }
            if (window.phoneModel().isAndroid) {
              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(image, 0, 0, width, height);
            }
            break;
        }
        resolve(canvas);
      });
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * 将手机拍摄的照片压缩
 * @param {*} canvas
 * @param {*} image 原始图片
 * @param {number} width 原始宽度
 * @param {number} height 原始高度
 * @param {number} maxValue 压缩后的宽或高的最大值
 * @returns canvas 返回 canvas 可以根据需要转成图片或者 blob
 */
window.compressImage = function(canvas, image, maxValue) {
  return new Promise((resolve, reject) => {
    try {
      Exif.getData(image, () => {
        const originWidth = Exif.getTag(image, 'PixelXDimension') || image.width;
        const originHeight = Exif.getTag(image, 'PixelYDimension') || image.height;
        let width = 0,
          height = 0;
        console.log(originWidth, originHeight);
        if (originWidth > originHeight) {
          // 如果比最大值小就不压缩
          if (originWidth <= maxValue) {
            width = originWidth;
            height = originHeight;
          } else {
            width = maxValue;
            height = Math.round((maxValue * originHeight) / originWidth);
          }
        } else {
          if (originHeight <= maxValue) {
            width = originWidth;
            height = originHeight;
          } else {
            height = maxValue;
            width = Math.round((maxValue * originWidth) / originHeight);
          }
        }
        console.log(width, height);

        // 将新的宽高赋给 canvas
        // 需要处理平台的兼容性问题，不知道是什么原因，iOS 照片的旋转参数是 6
        // 但是图像没有旋转，只是宽高反了，所以需要针对 iOS 做一下处理

        // Android 的照片和宽高都是反的，所以只需要将图片翻转一下重绘即可
        const ctx = canvas.getContext('2d');
        if (window.phoneModel().isiOS) {
          canvas.width = height;
          canvas.height = width;
          ctx.drawImage(image, 0, 0, height, width);
        }
        if (window.phoneModel().isAndroid) {
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(image, 0, 0, width, height);
        }
        resolve(canvas);
      });
    } catch (error) {
      reject(error);
    }
  });
};

// 判断 iOS 和 Android
window.phoneModel = function() {
  const userAgent = navigator.userAgent;
  const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
  return {
    isiOS,
    isAndroid,
  };
};

/* 将图片base64数据的dataURL转换成Blob对象
 * @Method  window.dataURLtoBlob
 * @Param   Require [String] dataUrl base64数据流
 * @Return  [Object] Blob对象 */
window.dataURLtoBlob = base64 => {
  var base64Arr = base64.split(',');
  var imgtype = '';
  var base64String = '';
  if (base64Arr.length > 1) {
    //如果是图片base64，去掉头信息
    base64String = base64Arr[1];
    imgtype = base64Arr[0].substring(base64Arr[0].indexOf(':') + 1, base64Arr[0].indexOf(';'));
  }
  // 将base64解码
  var bytes = atob(base64String);
  //var bytes = base64;
  var bytesCode = new ArrayBuffer(bytes.length);
  // 转换为类型化数组
  var byteArray = new Uint8Array(bytesCode);

  // 将base64转换为ascii码
  for (var i = 0; i < bytes.length; i++) {
    byteArray[i] = bytes.charCodeAt(i);
  }

  // 生成Blob对象（文件对象）
  return new Blob([bytesCode], { type: imgtype });
};

window.uploadBlobToMFSOSS = (signInfoUrl, signInfoParams, Blob, name, dir, success, fail) => {
  axios.post(signInfoUrl, signInfoParams).then(res => {
    var signInfo = res.result;
    var res = this.uploadBlobToNewOSS(Blob, name, dir, signInfo.signatureVO || signInfo);
    if (res) {
      success(signInfo);
    } else {
      fail();
    }
  });
};

window.uploadBlobToNewOSS = (Blob, name, dir, signInfo) => {
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    var fd = new FormData();
    fd.append('OSSAccessKeyId', signInfo.accessId);
    fd.append('policy', signInfo.policy);
    fd.append('callback', signInfo.callback);
    fd.append('Filename', name);
    fd.append('expire', signInfo.expire);
    fd.append('signature', signInfo.signature);
    fd.append('key', signInfo.key);
    fd.append('file', Blob);
    fd.append('success_action_status', 200);
    xhr.open('POST', signInfo.host.replace(/http:/, 'https:'), true);
    xhr.onload = () => {
      const result = JSON.parse(xhr.responseText);
      resolve(result.url);
    };
    xhr.send(fd);
  });
};

/* 将图片Blob对象上传到阿里云服务
 * @Method  window.uploadBlobToOSS()
 * @Param   Require [Object] Blob Blob对象
 *          Require [String] name 文件名称
 * @Return  [String] 图片网络地址 */
window.uploadBlobToOSS = (Blob, name, instId, bizCode = 'UPLOAD_COMMON', needId) => {
  return axios
    .MFS('anon/mfs/webTokenWithAccessUrl', {
      bizCode,
      resourceName: name,
      instId: instId || '1000000000000000000',
    })
    .then(res => {
      const signInfo = res.result;
      const { url } = res.result;
      return window.uploadBlobToNewOSS(Blob, name, null, signInfo.signatureVO || signInfo).then(() => {
        if (needId) {
          return res.result;
        } else {
          return url;
        }
      });
    });
};
// 存储收费最新改造上传方法
/**
 * @description:
 * @param blob:上传文件，
 * @param name：文件名字，
 * @param type: 文件类型 如 image/png  image/jpeg...
 * @param bizCode：业务code,
 * @param studentId:学员id,
 * @return dataType:'url'默认返回上传链接，否则返回上传信息全部里面有resourceId
 */
window.newUploadBlobToOSS = data => {
  const { blob, name, type, bizCode = 'UPLOAD_COMMON', dir, dataType = 'url', studentId, instId, needId } = data;
  const specialCodes = ['UPLOAD_ELE_CONTRACT'];
  const originType = type.split('/')[1] === 'mpeg' ? 'mp3' : type.split('/')[1];
  const oriResourceName = name.length > 50 ? name.substring(0, 40) + name.substring(name.length - 10, name.length) : name;
  let resourceName = window.random_string(16) + '.' + originType; //用文件名字加type拼接
  // 上传图片和视频
  let params = {
    resourceName,
    oriResourceName,
    bizCode,
    instId: instId || '1000000000000000000',
  };
  if (studentId) {
    params['userType'] = 'STUDENT';
    params['userId'] = studentId;
  }
  if (specialCodes.indexOf(bizCode) > -1) {
    params['data'] = { uploadId: 0 };
  }
  if (bizCode === 'UPLOAD_REGISTER_STUDENT_FACE') {
    params['data'] = { studentId };
  }

  // UPLOAD_REGISTER_STUDENT_FACE
  // data:{"studentId":xxx}
  return axios.MFS('anon/mfs/webTokenWithAccessUrl', params).then(res => {
    const signInfo = res.result;
    const { url } = res.result;
    return window.uploadBlobToNewOSS(blob, name, null, signInfo.signatureVO || signInfo).then(() => {
      if (needId) {
        return res.result;
      } else {
        return url;
      }
    });
  });
};

/**
 * 生成指定长度的随机字符串
 * @param len
 * @returns {string}
 */
window.random_string = len => {
  len = len || 32;
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const maxPos = chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

window.XMTDEVENT = (name, label, mk) => {
  if (!window.TDAPP) {
    return;
  }
  // const { instType, instServiceTime, instScale } = window.userAdminInfo;
  TDAPP.onEvent(name, label, mk);
};

window.timeFilter = time => {
  const timeUnit = 60;
  let hour = Math.floor(time / timeUnit);
  let minute = time % timeUnit;
  if (hour.toString().length == 1) {
    hour = '0' + hour;
  }
  if (minute.toString().length == 1) {
    minute = '0' + minute;
  }

  return hour + ':' + minute;
};

/**
 * 时间格式
 * @param format 时间格式
 * @param timestamp  时间戳
 */
window.formatDate = (format, timestamp) => {
  if (!timestamp) return '';

  if (timestamp == 0) return '';

  const date = new Date(parseInt(timestamp));
  let y = date.getFullYear(),
    m = date.getMonth() + 1,
    d = date.getDate(),
    h = date.getHours(),
    i = date.getMinutes(),
    s = date.getSeconds(),
    w = date.getDay(),
    week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  h = h < 10 ? '0' + h : h;
  i = i < 10 ? '0' + i : i;
  s = s < 10 ? '0' + s : s;
  return format
    .replace('YYYY', y)
    .replace('MM', m)
    .replace('DD', d)
    .replace('H', h)
    .replace('i', i)
    .replace('s', s)
    .replace('WW', week[w]);
};

window.formatMsgCreateTime = createTime => {
  const newTime =
    moment().year() > moment(parseInt(createTime)).year()
      ? formatDate('YYYY-MM-DD H:i', parseInt(createTime))
      : moment().dayOfYear() - 1 > moment(parseInt(createTime)).dayOfYear()
      ? formatDate('MM-DD H:i', parseInt(createTime))
      : moment().dayOfYear() - 1 == moment(parseInt(createTime)).dayOfYear()
      ? '昨天 ' + formatDate('H:i', parseInt(createTime))
      : Math.floor((moment().valueOf() - parseInt(createTime)) / 1000 / 60) > 60
      ? '今天' + formatDate('H:i', parseInt(createTime))
      : Math.floor((moment().valueOf() - parseInt(createTime)) / 1000 / 60) > 1
      ? Math.floor((moment().valueOf() - parseInt(createTime)) / 1000 / 60) + '分钟前'
      : '刚刚';
  return newTime;
};

window.throttle = function(fn, delay = 200) {
  let lastDate = 0; // 上次执行事件

  return function() {
    const context = this,
      argument = arguments;
    const now = +new Date();
    if (now - lastDate > delay) {
      lastDate = now;
      fn.apply(context, argument);
    }
  };
};

window.isMobile = function() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(navigator.userAgent) || window.innerWidth < 500;
};

window.setScale = function() {
  if (window.top !== window) {
    return;
  }
  let pageScale = 1;
  let width = document.documentElement.clientWidth || 375;
  let height = document.documentElement.clientHeight || 570;

  if (width / height >= 375 / 570) {
    pageScale = height / 570;
  } else {
    pageScale = width / 375;
  }
  let content = 'width=375, initial-scale=' + pageScale + ', maximum-scale=' + pageScale + ', user-scalable=no';

  document.getElementById('viewport').setAttribute('content', content);
};
window.saasBasicTypeEnum = function(type) {
  let str = null;
  switch (type) {
    case 'UNKNOWN':
      str = 1;
      break;
    case 'STANDARD':
    case 'BASIC':
      str = 3;
      break;
    case 'ADVANCED':
    case 'NEWADVANCED':
      str = 4;
      break;
    case 'ULTIMATE':
    case 'SPECIALTY':
      str = 5;
      break;
    case 'CHAIN': // 安卓访问不能超过5M
    case 'NEWCHAIN':
      str = 6;
      break;
    case 'SPORT':
      str = 7;
      break;
    case 'AESTHETIC':
      str = 8;
      break;
    case 'SPORT':
      str = 7;
      break;
    case 'NEWBASIC':
      str = 9;
      break;
    case 'LEAD':
      str = 10;
      break;
    case 'ENJOY':
      str = 11;
      break;
    case 'ENJOY':
      str = 12;
      break;
    default:
      break;
  }
  return str;
};

window.resetScale = function() {
  let content = 'width=device-width, initial-scale=1, user-scalable=no';

  document.getElementById('viewport').setAttribute('content', content);
};



// WEBPACK FOOTER //
// ./src/core/function.js